import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import LanguageSelector from './LanguageSelector';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const location = useLocation();
  const { t } = useLanguage();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return null;
  }

  return (
    <nav className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/80 backdrop-blur-xl" data-testid="main-navbar">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_5769230e-7a66-4b7d-9294-6503e125a0b4/artifacts/muqtjev5_IMG_5362.jpeg" 
              alt="A-One Tourism Logo" 
              className="w-12 h-12 rounded-full object-cover border-2 border-[#009FB7]"
            />
            <div>
              <h1 className="text-xl font-heading font-bold text-[#1A4D7F]">A-ONE TOURISM</h1>
              <p className="text-xs text-slate-500">Visa Services</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-slate-700 hover:text-[#1A4D7F] font-medium transition-colors" data-testid="nav-home">
              {t.nav.home}
            </Link>
            <Link to="/apply" className="text-slate-700 hover:text-[#1A4D7F] font-medium transition-colors" data-testid="nav-apply">
              {t.nav.applyForVisa}
            </Link>
            <Link to="/track" className="text-slate-700 hover:text-[#1A4D7F] font-medium transition-colors" data-testid="nav-track">
              {t.nav.trackApplication}
            </Link>
            <LanguageSelector variant="minimal" />
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-2">
            <LanguageSelector variant="minimal" />
            <button
              className="p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-button"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="md:hidden mt-4 flex flex-col gap-4 pb-4"
            data-testid="mobile-menu"
          >
            <Link to="/" className="text-slate-700 hover:text-[#1A4D7F] font-medium" onClick={() => setMobileMenuOpen(false)}>
              {t.nav.home}
            </Link>
            <Link to="/apply" className="text-slate-700 hover:text-[#1A4D7F] font-medium" onClick={() => setMobileMenuOpen(false)}>
              {t.nav.applyForVisa}
            </Link>
            <Link to="/track" className="text-slate-700 hover:text-[#1A4D7F] font-medium" onClick={() => setMobileMenuOpen(false)}>
              {t.nav.trackApplication}
            </Link>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;